export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./StandardHeader.vue?vue&type=template&id=d45b470a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/StandardHeader.vue?vue&type=template&id=d45b470a&scoped=true
// module id = 136
// module chunks = 0